import {InputButton, Image} from '@emersya/mpa-components';
import * as CM from '@emersya/mpa-components-manager';

export interface IScreenshotsButtonComponentConfiguration extends InputButton.Configuration {
	URL: string;
};

export class ScreenshotsButtonComponent extends InputButton.Component {

	private _isInProcessing = false;
	get isInProcessing() {
		return this._isInProcessing;
	};

	private async internalTakeScreenshot() {
		const camera = await app.viewer.getCamera();
		const screenshot = await app.viewer.takeSaveScreenshotGetURL({
			height: 512,
			width: 1024,
			transparentBackground: false,
			camera: camera.camera
		});
		const response = await fetch(screenshot.screenshot);
		if (!response) {
			this.component_throwUserError('Issue during fetching render', {});
		}
		const blob = await response.blob();
		const a = document.createElement('a');
		a.href = URL.createObjectURL(blob);
		a.download = 'screenshot.png';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(a.href);
	};

	async takeScreenshot() {
		if (this._isInProcessing) {
			return;
		}
		const viewerLoader = app.viewer.component_find('@.loader');
		if (!viewerLoader) {
			this.component_throwLibraryError('Viewer loader component not found!', {});
		}
		try {
			this.component_DOM.classList.add('in-processing');
			this._isInProcessing = true;
			await viewerLoader.component_enable();
			await this.internalTakeScreenshot();
		} catch (error: any) {
			this.component_throwBoundError('Cannot generate screenshot!', {}, error);
		} finally {
			await viewerLoader.component_disable();
			this._isInProcessing = false;
			this.component_DOM.classList.remove('in-processing');
		}
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IScreenshotsButtonComponentConfiguration
	) {
		configuration['@innerConfigurations'] = {
			icon: <Image.Configuration>{
				URL: configuration.URL,
				'@translations': {
					'@name': {
						'fr': 'Icône screenshot',
						'en': 'Icon screenshot'
					}
				}
			}
		};
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = ScreenshotsButtonComponent;
	export type Component = ScreenshotsButtonComponent;
	export type Configuration = IScreenshotsButtonComponentConfiguration;
}
;
import manifestXMLSource from './ScreenshotsButton.xml';
import './ScreenshotsButton.scss';

CM.Manager.declare({
	id: 'screenshotsButton',
	type: ScreenshotsButtonComponent,
	manifest: manifestXMLSource
});
